import BtnLoader from "../../layout/BtnLoader";

const FilledButton = ({ type="button", className="btn btn_gray", value="Clear", id, loading, ...rest }) => {
    return (
        <button disabled={loading} {...rest} type={type} className={`${className} ${loading ? id : ''}`}>{loading ? <BtnLoader /> : value}</button>
    )
};

export  default FilledButton